import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { SiteNav } from "@/components/SiteChrome";

const Thanks = ({ status }) => (
  <div className="text-center fade-up" data-testid="bw-thanks">
    <Heart className="h-10 w-10 text-pinkb mx-auto" />
    <h1 className="font-serif uppercase text-3xl text-navy mt-4">Thank you.</h1>
    <p className="text-muted-foreground mt-3">{status === "private" ? "Lindsay reads every one, and this stays between you." : "Lindsay reads every one, and might share yours on the website."}</p>
    <Link to="/app/membership" data-testid="bw-membership-link" className="mt-6 inline-block rounded-full bg-pinkb hover:bg-pinkb/90 text-white px-6 py-2.5 text-sm transition-colors">Use my founding code</Link>
  </div>
);

export default function BetaWrapup() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ answer: "", display_name: "", publish_ok: true });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  useEffect(() => {
    api.get(`/beta-wrapup/${token}`).then((r) => { setD(r.data); setF((x) => ({ ...x, display_name: r.data.name || "" })); }).catch((e) => setErr(errMsg(e)));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api.post(`/beta-wrapup/${token}`, f); setSent(r.data); window.scrollTo({ top: 0 }); } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="relative z-10 min-h-screen bg-background"><SiteNav />
      <div className="max-w-2xl mx-auto px-6 py-14" data-testid="beta-wrapup">
        {err && <p className="rounded-xl bg-rose-50 border border-rose-200 p-4" data-testid="bw-error">{err}. Please use the link from your email, or contact lindsay@rootsmarketingco.uk.</p>}
        {d && (sent || d.done ? <Thanks status={sent?.status} /> : (
          <form onSubmit={submit} className="space-y-8 fade-up" data-testid="bw-form">
            <div>
              <div className="eyebrow mb-3">The Roots Club beta · one last question</div>
              <h1 className="font-serif uppercase text-4xl text-navy leading-[0.95]">What made the biggest difference{d.name ? `, ${d.name}` : ""}?</h1>
              <p className="mt-3 text-muted-foreground">To your business, during the beta. One line is perfect.</p>
            </div>
            <Textarea required minLength={2} rows={4} value={f.answer} onChange={(e) => setF({ ...f, answer: e.target.value })} data-testid="bw-answer" className="bg-white" />
            <div className="rounded-2xl bg-secondary p-5 space-y-4">
              <label className="flex items-start gap-3 text-sm">
                <Checkbox checked={f.publish_ok} onCheckedChange={(v) => setF({ ...f, publish_ok: !!v })} data-testid="bw-publish-ok" className="mt-0.5" />
                Lindsay can share this on the website
              </label>
              {f.publish_ok && <label className="block text-sm space-y-1"><span className="font-medium text-navy">Name to show</span>
                <Input value={f.display_name} onChange={(e) => setF({ ...f, display_name: e.target.value })} maxLength={120} data-testid="bw-display-name" className="bg-white" /></label>}
            </div>
            <Button type="submit" disabled={busy} data-testid="bw-submit" className="rounded-full bg-pinkb hover:bg-pinkb/90 text-white px-8">
              {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Send my answer
            </Button>
          </form>
        ))}
      </div>
    </div>
  );
}
